import "swiper/css";
import "swiper/css/navigation";
import "../../scss/DetailView.scss";
import "../../scss/Common.scss";
import "../../scss/Swiper.scss";
import ReactMarkdown from "react-markdown";
import ImageSlide from "../../components/ImageSlide";

export default function SlideView({
  images,
  content,
}: {
  images: string[];
  content: string;
}) {
  return (
    <div>
      {Array.isArray(images) && images.length > 0 && (
        <ImageSlide images={images} />
      )}
      <ReactMarkdown
        components={{
          img: ({ node, ...props }) => (
            <img
              style={{
                display: "block",
                margin: "0 auto",
                maxWidth: "80%",
                height: "auto",
                borderRadius: "8px",
              }}
              {...props}
            />
          ),
        }}
        className="prose max-w-none"
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
